/* Enquiry form. Sends JSON to the LIRO Enquiries app through Shopify's App Proxy.
 * Privacy: nothing personal is put in URLs, storage or the console. */
(() => {
  const form = document.querySelector('[data-brief-form]');
  if (!form) return;

  const statusEl = document.querySelector('[data-brief-status]');
  const doneEl = document.querySelector('[data-brief-done]');
  const submitBtn = document.querySelector('[data-brief-submit]');
  const savedBox = document.querySelector('[data-brief-saved]');
  const chips = document.querySelector('[data-brief-chips]');
  const HANDLE = /^[a-z0-9-]{1,80}$/;
  let designs = [];

  const params = new URLSearchParams(location.search);
  const path = params.get('path');
  if (path) {
    const r = form.querySelector(`input[name="entryPath"][value="${CSS.escape(path)}"]`);
    if (r) r.checked = true;
  }
  const fromMySpace = window.liroMySpace ? window.liroMySpace.all() : [];
  const fromLink = params.get('design');
  designs = Array.from(new Set([...(fromLink && HANDLE.test(fromLink) ? [fromLink] : []), ...fromMySpace])).filter((h) => HANDLE.test(h)).slice(0, 30);

  const renderChips = async () => {
    chips.textContent = '';
    if (!designs.length) { savedBox.hidden = true; return; }
    savedBox.hidden = false;
    for (const handle of designs) {
      const li = document.createElement('li');
      li.className = 'lbrief__chip';
      const label = document.createElement('span');
      label.textContent = handle.replace(/-/g, ' ');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('aria-label', `Remove ${handle.replace(/-/g, ' ')} from this enquiry`);
      remove.textContent = '×';
      remove.addEventListener('click', () => { designs = designs.filter((h) => h !== handle); renderChips(); });
      li.append(label, remove);
      chips.append(li);
      fetch(`/products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).then((p) => { if (p && p.title) label.textContent = p.title; }).catch(() => {});
    }
  };
  renderChips();

  const say = (msg) => { statusEl.textContent = msg; };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    say('');
    if (!form.checkValidity()) {
      form.reportValidity();
      say('Please check the highlighted fields.');
      return;
    }
    const fd = new FormData(form);
    const val = (k) => String(fd.get(k) || '').trim();
    const body = {
      name: val('name'),
      email: val('email'),
      consent: fd.get('consent') === 'on',
      website: val('website'),
    };
    ['interest', 'phone', 'location', 'propertySize', 'timeframe', 'budgetBracket', 'priorities', 'message', 'entryPath', 'visitType', 'serviceArea'].forEach((k) => { if (val(k)) body[k] = val(k); });
    const rooms = fd.getAll('rooms').map(String);
    if (rooms.length) body.rooms = rooms;
    if (designs.length) body.savedDesigns = designs;

    submitBtn.disabled = true;
    say('Sending…');
    try {
      const res = await fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const out = await res.json().catch(() => ({}));
      if (res.ok && out.ok) {
        form.hidden = true;
        document.querySelector('[data-brief-ref]').textContent = out.reference || '';
        doneEl.hidden = false;
        doneEl.focus();
      } else if (res.status === 429) {
        say('You have sent a few enquiries already. Please try again a little later.');
      } else if (res.status === 422) {
        say('Some details need another look. Please check your name, phone and email.');
      } else {
        say('We could not send your enquiry just now. Please try again shortly.');
      }
    } catch (err) {
      say('We could not send your enquiry just now. Please check your connection and try again.');
    } finally {
      submitBtn.disabled = false;
    }
  });
})();
